module.exports = __webpack_public_path__ + "static/media/dpmodemx_701.c99ce666.ico";